/* eslint-disable */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import 'flatpickr/dist/flatpickr.css'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {purchaseProposalCreate} from '../../../redux/slices/purchase.slice'
import {proposalCompanyLookup} from '../../../redux/slices/lookup.slice'
import {InputPrice, Select} from '../../'
import {PurchaseProposalStatus} from '../../../helpers'

const PurchaceProposalModal = ({onOpen, onClose, error, id}) => {
  const [show, setShow] = useState(onOpen)
  const intl = useIntl()
  const {proposalCompanyLookupList} = useSelector((state) => state.lookup)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(proposalCompanyLookup())
  }, [])

  useEffect(() => {
    setShow(onOpen)
  }, [onOpen])

  const handleClose = () => {
    setShow(false)
    onClose && onClose()
  }

  useEffect(() => {
    if (error && show) {
      setShow(false)
    }
  }, [error])

  const validSchema = Yup.object().shape({
    Name: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    TotalPrice: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    PurchaseProposalStatusId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    TotalPriceWithTax: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
  })

  const [formValues] = useState({
    PurchaseRequestId: id,
    Name: '',
    ProposalCompanyId: '',
    TotalPrice: 0,
    ProposalFile: null,
    PurchaseProposalStatusId: '',
    TotalPriceWithTax: 0,
    Transportation: '',
    PaymentDetail: '',
    DeliveryTime: '',
    Brand: '',
    ProductTotalPrice: 0,
    LaborTotalPrice: 0,
    TSEFile: null,
  })

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: validSchema,
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      dispatch(purchaseProposalCreate(values))
      setShow(false)
      onClose && onClose()
      resetForm()
    },
  })

  return (
    <>
      <Modal
        className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
        id='kt_inbox_compose'
        role='dialog'
        data-backdrop='false'
        aria-hidden='true'
        tabIndex='-1'
        show={show}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        onHide={handleClose}
        size='lg'
      >
        <div className='modal-content'>
          <form className='form position-relative' onSubmit={formik.handleSubmit} noValidate>
            <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
              <h5 className='fw-bold m-0'>
                {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS'})}
              </h5>
              <div className='d-flex ms-2'>
                <div
                  className='btn btn-icon btn-sm btn-light-primary ms-2'
                  data-bs-dismiss='modal'
                  onClick={handleClose}
                >
                  <KTSVG className='svg-icon-1' path='/images/icons/duotune/arrows/arr061.svg' />
                </div>
              </div>
            </div>

            <div className='d-block py-5 ps-8 pe-5'>
              <div className='row mb-6'>
                <label className='col-lg-4 required fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.NAME'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('Name')}
                  />
                  {formik.touched.Name && formik.errors.Name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.Name}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PRODUCTTOTALPRICE'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('ProductTotalPrice')}
                    onChange={(value) => formik.setFieldValue('ProductTotalPrice', Number(value))}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.LABORTOTALPRICE'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('LaborTotalPrice')}
                    onChange={(value) => formik.setFieldValue('LaborTotalPrice', Number(value))}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2 required'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TOTALPRICE'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('TotalPrice')}
                    onChange={(value) => formik.setFieldValue('TotalPrice', Number(value))}
                  />
                  {formik.touched.TotalPrice && formik.errors.TotalPrice && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.TotalPrice}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2 required'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TOTALPRICEWITHTAX'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <InputPrice
                    {...formik.getFieldProps('TotalPriceWithTax')}
                    onChange={(value) => formik.setFieldValue('TotalPriceWithTax', Number(value))}
                  />
                  {formik.touched.TotalPriceWithTax && formik.errors.TotalPriceWithTax && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.TotalPriceWithTax}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6 position-relative z-index-2'>
                <label className='col-lg-4 required fw-bold fs-6 mb-2'>
                  {intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PURCHASEPROPOSALSTATUSNAME',
                  })}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <Select
                    data={PurchaseProposalStatus}
                    required
                    {...formik.getFieldProps('PurchaseProposalStatusId')}
                    onChange={(item) =>
                      formik.setFieldValue('PurchaseProposalStatusId', Number(item?.value))
                    }
                    textType={'intl'}
                    menuPortalTarget={null}
                  />
                  {formik.touched.PurchaseProposalStatusId &&
                    formik.errors.PurchaseProposalStatusId && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.PurchaseProposalStatusId}</span>
                        </div>
                      </div>
                    )}
                </div>
              </div>

              <div className='row mb-6 position-relative z-index-1'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PROPOSALFILEURL'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <label
                    htmlFor='ProposalFile'
                    className='btn btn-bg-light w-100 btn-active-color-primary position-relative overflow-hidden text-muted'
                  >
                    <input
                      id='ProposalFile'
                      className='position-absolute z-index-2 opacity-0'
                      style={{width: 0, height: 0}}
                      type='file'
                      accept='image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.kmz,.kml,.ncz,.dwg'
                      name={'ProposalFile'}
                      onChange={(event) =>
                        formik.setFieldValue('ProposalFile', event.currentTarget.files[0])
                      }
                    />
                    <KTSVG
                      path='/images/icons/duotune/communication/com008.svg'
                      className='svg-icon-2 position-relative z-index-1'
                    />

                    <span>
                      {formik.values.ProposalFile
                        ? formik.values.ProposalFile.name
                        : intl.formatMessage({id: 'FILE.NEWFILE'})}
                    </span>
                  </label>
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.COMPANYNAME'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <Select
                    data={proposalCompanyLookupList}
                    {...formik.getFieldProps('ProposalCompanyId')}
                    onChange={(item) =>
                      formik.setFieldValue('ProposalCompanyId', Number(item?.value))
                    }
                    menuPortalTarget={null}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TRANSPORTATION'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('Transportation')}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PAYMENTDETAIL'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('PaymentDetail')}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.DELIVERYTIME'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('DeliveryTime')}
                  />
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.BRAND'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <input
                    type='text'
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    autoComplete='off'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('Brand')}
                  />
                </div>
              </div>

              <div className='row mb-6 position-relative z-index-1'>
                <label className='col-lg-4 fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TSEFILE'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <label
                    htmlFor='TSEFile'
                    className='btn btn-bg-light w-100 btn-active-color-primary position-relative overflow-hidden text-muted'
                  >
                    <input
                      id='TSEFile'
                      className='position-absolute z-index-2 opacity-0'
                      style={{width: 0, height: 0}}
                      type='file'
                      accept='image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.kmz,.kml,.ncz,.dwg'
                      name={'TSEFile'}
                      onChange={(event) =>
                        formik.setFieldValue('TSEFile', event.currentTarget.files[0])
                      }
                    />
                    <KTSVG
                      path='/images/icons/duotune/communication/com008.svg'
                      className='svg-icon-2 position-relative z-index-1'
                    />

                    <span>
                      {formik.values.TSEFile
                        ? formik.values.TSEFile.name
                        : intl.formatMessage({id: 'FILE.NEWFILE'})}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div className='d-flex align-items-center justify-content-center py-5 ps-8 pe-5 border-top'>
              <div className='d-flex align-items-center me-3'>
                <button className='btn btn-light me-3' onClick={handleClose}>
                  {intl.formatMessage({id: 'BUTTON.CLOSE'})}
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  {intl.formatMessage({id: 'BUTTON.SUBMIT'})}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

PurchaceProposalModal.propTypes = {
  onOpen: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
}

PurchaceProposalModal.defaultProps = {
  onOpen: false,
}

export {PurchaceProposalModal}
